module.exports = __webpack_public_path__ + "static/media/menu-line.1c63601f.svg";